import { useContext } from 'react';
import { Context } from '../context/AppContextBuilder';
import { TermsTemplate } from '../templates/TermsTemplate';

export const Terms = () => {
  const { emiPrefix, termsOfUse } = useContext(Context);
  document.title = `${emiPrefix} ${termsOfUse}`;
  return <TermsTemplate />;
};
